import cn from 'classnames';
import Price from 'components/price';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface PriceComposition {
  currentPrice: number;
  priceBefore?: number | null;
  cents?: boolean;
  reverseOrder?: boolean;
  bold?: boolean;
  color?: 'neutral' | 'accent' | 'primary';
  size?: 'sm' | 'md' | 'lg';
  /** 'row' (default) renders the strike + current price side by side; 'column' stacks them with the strike on top. */
  layout?: 'row' | 'column';
  className?: string;
}

const priceColors = {
  neutral: 'text-text-bg-secondary',
  accent: 'text-error-main',
  primary: 'text-text-light-bg-primary',
};

const priceSizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
};

export const PriceComposition: FC<PriceComposition> = ({
  priceBefore,
  currentPrice,
  cents,
  reverseOrder = false,
  bold = true,
  color = 'accent',
  size = 'lg',
  layout = 'row',
  className,
}) => {
  return (
    <div
      className={cn(
        twMerge(
          layout === 'column' ? 'flex flex-col gap-0' : 'flex flex-wrap items-center gap-2',
          className
        )
      )}
    >
      {priceBefore && priceBefore > currentPrice && (
        <span
          className={cn(
            'text-text-light-bg-secondary text-sm line-through',
            reverseOrder ? 'order-last' : ''
          )}
          data-test="strike-price"
        >
          <Price cents={cents} value={priceBefore} />
        </span>
      )}
      <span
        className={cn(priceColors[color], priceSizes[size], {
          'font-black': bold,
        })}
        data-test="current-price"
      >
        <Price cents={cents} value={currentPrice} />
      </span>
    </div>
  );
};
